// src/components/Gallery.jsx
export default function Gallery() {
  const images = [
    {
      url: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?auto=format&fit=crop&w=800&q=80",
      title: "Main Weight Room",
      zone: "Zone A",
      description: "Free weights and power racks"
    },
    {
      url: "https://images.unsplash.com/photo-1583454110551-21f2fa2afe61?auto=format&fit=crop&w=800&q=80",
      title: "CrossFit & Functional Area",
      zone: "Zone B",
      description: "Rigs, ropes and functional training"
    },
    {
      url: "https://images.unsplash.com/photo-1517836357463-d25dfeac3438?auto=format&fit=crop&w=800&q=80",
      title: "Cardio & Machine Zone",
      zone: "Zone C",
      description: "Treadmills, ellipticals & more"
    },
    {
      url: "https://images.unsplash.com/photo-1605296867304-46d5465a13f1?auto=format&fit=crop&w=800&q=80",
      title: "Dumbbell & Plate Area",
      zone: "Zone D",
      description: "Extensive dumbbell selection"
    },
    {
      url: "https://images.unsplash.com/photo-1571019613454-1cf54994b0d6?auto=format&fit=crop&w=800&q=80",
      title: "Yoga & Stretching Zone",
      zone: "Zone E",
      description: "Peaceful area for mobility work"
    },
  ];

  return (
    <section className="py-10 md:py-16 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-10">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-3">
          Our Gym Gallery
        </h2>
        <p className="text-slate-400 text-base md:text-lg">
          A glimpse inside KrioGym Ludhiana – your free training space
        </p>
      </div>

      {/* Horizontal Scroll Gallery - Snap + Responsive */}
      <div className="flex overflow-x-auto gap-4 pb-6 scrollbar-hide snap-x snap-mandatory">
        {images.map((img, index) => (
          <div
            key={index}
            className="snap-center shrink-0 w-[85vw] sm:w-[65vw] md:w-[45vw] lg:w-[35vw] xl:w-[30vw] 
                       h-64 sm:h-80 md:h-96 rounded-2xl overflow-hidden relative 
                       border border-slate-700/50 shadow-xl group transition-all duration-300 hover:shadow-2xl"
          >
            {/* Image with fallback */}
            <img
              src={img.url}
              alt={img.title}
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              loading="lazy"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "https://via.placeholder.com/600x400/1a1a2e/ffffff?text=Image+Not+Available";
              }}
            />

            {/* Gradient Overlay */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent opacity-90 group-hover:opacity-70 transition-opacity duration-300" />

            {/* Caption */}
            <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
              <h3 className="text-white font-bold text-lg md:text-xl mb-1 drop-shadow-md">
                {img.title}
              </h3>
              <p className="text-primary text-xs md:text-sm uppercase font-semibold tracking-wide drop-shadow-md">
                {img.zone}
              </p>
              <p className="text-slate-200 text-xs md:text-sm mt-2 line-clamp-2">
                {img.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* Optional: "View More" hint */}
      <div className="text-center mt-6 text-slate-500 text-sm italic">
        Scroll → to explore more zones
      </div>
    </section>
  );
}


// export default function Gallery() {
//   const images = [
//     {
//       url: "https://lh3.googleusercontent.com/...main-weight-room...", // real image URL daal dena
//       title: "Main Weight Room",
//       zone: "Zone A"
//     },
//     {
//       url: "https://lh3.googleusercontent.com/...crossfit-area...",
//       title: "CrossFit & Functional Area",
//       zone: "Zone B"
//     },
//     {
//       url: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48", // placeholder
//       title: "Cardio Zone",
//       zone: "Zone C"
//     },
//   ];

//   return (
//     <section className="py-8 max-w-xl mx-auto px-5">
//       <h2 className="text-xl font-bold text-white mb-2">Gallery</h2>
//       <p className="text-slate-500 text-xs mb-5">A peek inside our facility in Ludhiana</p>

//       <div className="flex overflow-x-auto gap-4 pb-4 scrollbar-hide snap-x snap-mandatory">
//         {images.map((img, i) => (
//           <div 
//             key={i}
//             className="snap-center shrink-0 w-[85vw] sm:w-[70vw] md:w-[50vw] lg:w-[40vw] h-64 rounded-2xl overflow-hidden relative border border-slate-800 shadow-lg group"
//           >
//             <img 
//               src={img.url} 
//               alt={img.title}
//               className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
//             />
//             <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
//             <div className="absolute bottom-5 left-5 right-5">
//               <p className="text-white font-bold text-base">{img.title}</p>
//               <p className="text-primary text-xs uppercase font-bold mt-1">{img.zone}</p>
//             </div>
//           </div>
//         ))}
//       </div>
//     </section>
//   );
// }